import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import fileDownload from "js-file-download";
import { request } from "@/js/http/http_request.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import { TASTING_PHOTOS } from "@/js/lists.ts";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultFormAdd = {
  tastingPhotoRequiredId: null,
  nbBottles: 1,
  valid: false
};
export default {
  name: "TastingPhotoFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null,
    loggedUserData: Object
  },
  data: function data() {
    return {
      isAdminManaging: false,
      dialog: false,
      isLoading: false,
      photo: null,
      addingContent: {
        isConfiguring: false,
        form: _objectSpread({}, defaultFormAdd),
        availablePhotosRequired: {
          isPending: false,
          cancellationToken: null,
          items: []
        },
        isPending: false
      },
      cancellingContent: {
        isPending: false
      },
      handlingComment: {
        isConfiguringNew: false,
        form: {
          comment: null
        },
        updating: {
          isPending: false
        },
        removing: {
          isPending: false
        }
      },
      transferingPhoto: {
        isPending: false
      },
      cancellingPhoto: {
        isPending: false
      },
      TASTING_PHOTOS: TASTING_PHOTOS,
      formRules: formRules,
      filterIntegerKey: filterIntegerKey,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isEditable: function isEditable() {
      return this.photo && [TASTING_PHOTOS.TAKEN.STATUS.TO_TRANSFER.id].includes(this.photo.status);
    },
    isTransferable: function isTransferable() {
      return this.photo && this.photo.status === TASTING_PHOTOS.TAKEN.STATUS.TO_TRANSFER.id;
    },
    isCancellable: function isCancellable() {
      return this.photo && (this.isAdminManaging && this.photo.status !== TASTING_PHOTOS.TAKEN.STATUS.CANCELLED.id || !this.isAdminManaging && this.isEditable);
    },
    isCancelled: function isCancelled() {
      return this.photo && this.photo.status === TASTING_PHOTOS.TAKEN.STATUS.CANCELLED.id;
    },
    isTransferred: function isTransferred() {
      return this.photo && this.photo.status === TASTING_PHOTOS.TAKEN.STATUS.TRANSFERRED.id;
    },
    canCancelContent: function canCancelContent() {
      var _this$photo;
      return this.isEditable && ((_this$photo = this.photo) === null || _this$photo === void 0 || (_this$photo = _this$photo.contents) === null || _this$photo === void 0 ? void 0 : _this$photo.length) > 1;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isLoading || this.addingContent.isPending || this.cancellingContent.isPending || this.transferingPhoto.isPending || this.cancellingPhoto.isPending || this.handlingComment.removing.isPending || this.handlingComment.updating.isPending;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.isAdminManaging = hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS);
            _context.next = 3;
            return _this2.getEntity();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    confirmTransferPhoto: function confirmTransferPhoto() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$refs.confirm.open("Transfer photo", "Are you sure to declare this photo as transferred ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(confirm) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!confirm) {
                          _context2.next = 3;
                          break;
                        }
                        _context2.next = 3;
                        return _this3.transferPhoto();
                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    transferPhoto: function transferPhoto() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this4.transferingPhoto.isPending = true;
              _this = _this4;
              _context5.next = 4;
              return request("/v1/tasting-photos/" + _this4.photo.id + "/transferred", "put", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _this.transferingPhoto.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to update this photo status.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
              _this4.transferingPhoto.isPending = false;
              _this4.$emit("entityUpdated");
              _this4.$toasted.show("Photo transferred.", {
                type: "success"
              });
              _this4.close();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    confirmCancelPhoto: function confirmCancelPhoto() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this5.$refs.confirm.open("Cancel photo", "Are you sure to cancel this photo ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(confirm) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!confirm) {
                          _context6.next = 3;
                          break;
                        }
                        _context6.next = 3;
                        return _this5.cancelPhoto();
                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    cancelPhoto: function cancelPhoto() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this6.cancellingPhoto.isPending = true;
              _this = _this6;
              _context9.next = 4;
              return request("/v1/tasting-photos/" + _this6.photo.id, "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        _this.cancellingPhoto.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to cancel this photo.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 4:
              _this6.cancellingPhoto.isPending = false;
              _this6.$emit("entityUpdated");
              _this6.$toasted.show("Photo cancelled.", {
                type: "success"
              });
              _this6.close();
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    confirmCancelContent: function confirmCancelContent(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this7.$refs.confirm.open("Remove content", "Are you sure to remove this content ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(confirm) {
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!confirm) {
                          _context10.next = 3;
                          break;
                        }
                        _context10.next = 3;
                        return _this7.cancelContent(item);
                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    cancelContent: function cancelContent(item) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this8.cancellingContent.isPending = true;
              _this = _this8;
              _context13.next = 4;
              return request("/v1/tasting-photos/contents/" + item.id, "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        _this.cancellingContent.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to remove the content.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 4:
              _this8.photo.contents = _this8.photo.contents.filter(function (x) {
                return x.id !== item.id;
              });
              _this8.cancellingContent.isPending = false;
              _this8.$emit("entityUpdated");
              _this8.$toasted.show("Content removed.", {
                type: "success"
              });
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    startAddContent: function startAddContent() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _this9.getRequiredPhotosForUser();
            case 2:
              _this9.addingContent.isConfiguring = true;
              _this9.addingContent.form = _objectSpread({}, defaultFormAdd);
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    cancelAddingForm: function cancelAddingForm() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this10.addingContent.isConfiguring = false;
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    saveAddingContent: function saveAddingContent() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this, _this11$addingContent, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this11.addingContent.isPending = true;
              _this = _this11;
              _this11$addingContent = _this11.addingContent.form, valid = _this11$addingContent.valid, withoutValid = _objectWithoutProperties(_this11$addingContent, _excluded);
              _context17.next = 5;
              return request("/v1/tasting-photos/" + _this11.photo.id + "/contents/", "post", withoutValid, true, "api").catch(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        _this.addingContent.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to add the content.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 5:
              _context17.next = 7;
              return _this11.getEntity();
            case 7:
              _this11.addingContent.isPending = false;
              _this11.addingContent.isConfiguring = false;
              _this11.addingContent.form = _objectSpread({}, defaultFormAdd);
              _this11.$emit("entityUpdated");
              _this11.$toasted.show("Content added.", {
                type: "success"
              });
            case 12:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    getRequiredPhotosForUser: function getRequiredPhotosForUser() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this$addingContent$a;
        var _this, dataForSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this12.addingContent.availablePhotosRequired.isPending = true;
              _this12.addingContent.availablePhotosRequired.items = [];
              _this = _this12;
              (_this$addingContent$a = _this.addingContent.availablePhotosRequired.cancellationToken) === null || _this$addingContent$a === void 0 || _this$addingContent$a.cancel();
              _this.addingContent.availablePhotosRequired.cancellationToken = axios.CancelToken.source();
              dataForSearch = {
                userIds: [+_this12.photo.targetedUser.id],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(dataForSearch);
              _context18.next = 9;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api", null, _this.addingContent.availablePhotosRequired.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.addingContent.availablePhotosRequired.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load required photos.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context18.sent;
              _this12.addingContent.availablePhotosRequired.items = _toConsumableArray(response.data.value.map(function (x) {
                x.name = "From ".concat(x.fromReference.shorterReference(), ", ").concat(x.nbBottlesRemaining, "b. of ").concat(x.wine.displayName);
                return x;
              }));
              _this12.addingContent.availablePhotosRequired.isPending = false;
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    removeComment: function removeComment() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!_this13.handlingComment.isConfiguringNew) {
                _context20.next = 4;
                break;
              }
              _this13.handlingComment.isConfiguringNew = false;
              _context20.next = 14;
              break;
            case 4:
              _this13.handlingComment.removing.isPending = true;
              _this = _this13;
              _context20.next = 8;
              return request("/v1/tasting-photos/" + _this13.photo.id + "/comment", "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                    while (1) switch (_context19.prev = _context19.next) {
                      case 0:
                        _this.handlingComment.removing.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to remove the comment.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context19.stop();
                    }
                  }, _callee19);
                }));
                return function (_x8) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 8:
              _this13.handlingComment.removing.isPending = false;
              _this13.photo.comment = null;
              _this13.handlingComment.form.comment = null;
              _this13.handlingComment.isConfiguringNew = false;
              _this13.$emit("entityUpdated");
              _this13.$toasted.show("Comment removed.", {
                type: "success"
              });
            case 14:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    saveComment: function saveComment() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this14.handlingComment.updating.isPending = true;
              _this = _this14;
              _context22.next = 4;
              return request("/v1/tasting-photos/" + _this14.photo.id + "/comment", "put", _objectSpread({}, _this14.handlingComment.form), true, "api").catch(/*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                    while (1) switch (_context21.prev = _context21.next) {
                      case 0:
                        _this.handlingComment.updating.isPending = false;
                        errorData = getErrorData(e, {}, "Unable to update the comment.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context21.stop();
                    }
                  }, _callee21);
                }));
                return function (_x9) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 4:
              _this14.handlingComment.updating.isPending = false;
              _this14.photo.comment = _this14.handlingComment.form.comment;
              _this14.handlingComment.isConfiguringNew = false;
              _this14.$emit("entityUpdated");
              _this14.$toasted.show("Comment updated.", {
                type: "success"
              });
            case 9:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    getEntity: function getEntity() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _this15.isLoading = true;
              _this = _this15;
              _context23.next = 4;
              return request("/v1/tasting-photos/".concat(_this15.id), "get", null, true, "api").catch(function (e) {
                _this.isLoading = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get details of tasting photo", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context23.sent;
              _this15.photo = _objectSpread({}, response.data.value);
              _this15.handlingComment.form.comment = _this15.photo.comment;
              _this15.isLoading = false;
            case 8:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    downloadPhoto: function downloadPhoto() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var urlWithoutQueryParams, parts, extension, image, imageBlob;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              urlWithoutQueryParams = _this16.photo.absoluteUrlImage.split("?")[0];
              parts = urlWithoutQueryParams.split(".");
              extension = parts[parts.length - 1].toLowerCase();
              _context24.next = 5;
              return fetch(_this16.photo.absoluteUrlImage);
            case 5:
              image = _context24.sent;
              _context24.next = 8;
              return image.blob();
            case 8:
              imageBlob = _context24.sent;
              fileDownload(imageBlob, "tasting-proof.".concat(extension));
            case 10:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    open: function open() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _this17.resetData();
              _this17.dialog = true;
              _context25.next = 4;
              return _this17.getEntity();
            case 4:
              return _context25.abrupt("return", new Promise(function (resolve, reject) {
                _this17.resolve = resolve;
                _this17.reject = reject;
              }));
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      //not needed, at any dialog close, the component is destroyed
      this.photo = null;
      this.isLoading = false;
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};